import { render } from "./AccessDeniedBanner.vue?vue&type=template&id=137abd84&scoped=true&ts=true"
import script from "./AccessDeniedBanner.vue?vue&type=script&lang=ts"
export * from "./AccessDeniedBanner.vue?vue&type=script&lang=ts"

import "./AccessDeniedBanner.vue?vue&type=style&index=0&id=137abd84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137abd84"]])

export default __exports__